'use client';

import { c as _c } from "react/compiler-runtime";
import { ScrollArea as ScrollAreaPrimitive } from '@base-ui/react/scroll-area';
import { cn } from 'cn';
type ScrollAreaProps = ScrollAreaPrimitive.Root.Props;
export function ScrollArea(props) {
  const $ = _c(14);
  let children;
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== className) {
    t0 = cn("relative", className);
    $[4] = className;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== children) {
    t1 = <ScrollAreaPrimitive.Viewport data-slot="scroll-area-viewport" className="size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1">{children}</ScrollAreaPrimitive.Viewport>;
    $[6] = children;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ScrollBar />;
    t3 = <ScrollAreaPrimitive.Corner />;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  let t4;
  if ($[10] !== rest || $[11] !== t0 || $[12] !== t1) {
    t4 = <ScrollAreaPrimitive.Root data-slot="scroll-area" className={t0} {...rest}>{t1}{t2}{t3}</ScrollAreaPrimitive.Root>;
    $[10] = rest;
    $[11] = t0;
    $[12] = t1;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
type ScrollBarProps = ScrollAreaPrimitive.Scrollbar.Props;
export function ScrollBar(props) {
  const $ = _c(11);
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      className,
      orientation: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const orientation = t0 === undefined ? "vertical" : t0;
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ScrollAreaPrimitive.Thumb data-slot="scroll-area-thumb" className="relative flex-1 rounded-full bg-border" />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== orientation || $[8] !== rest || $[9] !== t1) {
    t3 = <ScrollAreaPrimitive.Scrollbar data-slot="scroll-area-scrollbar" data-orientation={orientation} orientation={orientation} className={t1} {...rest}>{t2}</ScrollAreaPrimitive.Scrollbar>;
    $[7] = orientation;
    $[8] = rest;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}